import type { ReactNode } from 'react';
import { AuthGate } from '@/auth/AuthGate';
import { useTenantAuth } from '@/auth/TenantAuthContext';
import { PORTAL_LOGIN } from '@/lib/routes';

export interface RequireTenantAuthProps {
  children: ReactNode;
}

/** Guards the root report routes — only a tenant session opens these (an SA session does not). */
export function RequireTenantAuth({ children }: RequireTenantAuthProps) {
  const { isAuthenticated } = useTenantAuth();
  return (
    <AuthGate isAuthenticated={isAuthenticated} loginPath={PORTAL_LOGIN}>
      {children}
    </AuthGate>
  );
}
